import { createPortal } from "react-dom";
import { ProgressSpinner } from "primereact/progressspinner";

import type { RequestLoadingViewModel } from "./types-request-loading";
import styles from "./request-loading.module.scss";

export function RequestLoadingView({
  visivel,
  bloqueando,
  comIndicador,
  rotulo,
}: RequestLoadingViewModel) {
  if (!visivel) return null;

  return createPortal(
    <div
      className={styles.root}
      data-testid="global-request-loading"
      data-blocking={bloqueando ? "true" : "false"}
      data-indicator={comIndicador ? "true" : "false"}
    >
      {bloqueando ? (
        <div className={styles.veil} data-testid="global-request-loading-veil" aria-hidden />
      ) : null}
      {comIndicador ? (
        <div
          className={styles.indicator}
          data-testid="global-request-loading-indicator"
          role="status"
          aria-live="polite"
          aria-busy={bloqueando}
        >
          <ProgressSpinner
            className={styles.spinner}
            strokeWidth="4"
            animationDuration="1s"
            aria-hidden
          />
          <span className={styles.srOnly}>{rotulo}</span>
        </div>
      ) : (
        <span className={styles.srOnly} role="status" aria-live="polite" aria-busy>
          {rotulo}
        </span>
      )}
    </div>,
    document.body,
  );
}
